import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";
import LoadingSpinner from "@/components/LoadingSpinner";

const Dashboard = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { toast } = useToast();
  const [hasCheckedInitialAuth, setHasCheckedInitialAuth] = useState(false);

  // Derived state to determine if auth is ready for decision making
  const isAuthReady = !loading && hasCheckedInitialAuth;

  console.log("Dashboard render - user:", user?.email || "null", "loading:", loading, "hasCheckedInitialAuth:", hasCheckedInitialAuth, "isAuthReady:", isAuthReady);

  // Track when we've completed the initial auth check
  useEffect(() => {
    if (!loading && !hasCheckedInitialAuth) {
      console.log("Initial auth check completed");
      setHasCheckedInitialAuth(true);
    }
  }, [loading, hasCheckedInitialAuth]);

  // Handle redirects only when auth state is ready
  useEffect(() => {
    if (!isAuthReady) {
      console.log("Auth not ready yet, waiting...");
      return;
    }

    console.log("Auth ready, processing navigation logic");

    if (!user) {
      console.log("No user found, redirecting to login");
      navigate("/login", { replace: true });
      return;
    }

    console.log("User found:", user.email, "profileType:", user.profileType);

    // Remove hardcoded admin checks - rely on database is_admin field
    
    // Redirect based on profile type
    if (user.profileType === "mentor") {
      console.log("Mentor user, redirecting to mentor dashboard");
      navigate("/mentor-dashboard", { replace: true });
    } else if (user.profileType === "mentee") {
      console.log("Mentee user, redirecting to mentee dashboard");
      navigate("/mentee-dashboard", { replace: true });
    } else if (user.profileType === "both") {
      console.log("Both-type user, defaulting to mentor dashboard");
      navigate("/mentor-dashboard", { replace: true });
    } else if (user.isAdmin) {
      console.log("Admin user, redirecting to admin dashboard");
      navigate("/admin", { replace: true });
    } else {
      console.log("Profile type not set, defaulting to mentee dashboard");
      toast({
        title: "Profile Type Not Set",
        description: "Redirecting to mentee dashboard by default.",
        variant: "default",
      });
      navigate("/mentee-dashboard", { replace: true });
    }
  }, [isAuthReady, user, navigate, toast]);

  // Show loading spinner while determining auth state
  if (!isAuthReady) {
    console.log("Showing loading spinner while auth state is being determined");
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // This should rarely be reached since we redirect when auth is ready
  return null;
};

export default Dashboard;
